import React from 'react';
import classnames from 'classnames';
import './message.scss';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

export function Message({
    heading,
    body,
    bodyLink,
    bodyLinkUrl,
    bodyLinkUrlStyle,
    type,
    icon,
    noBorder,
    iconXL,
    noBackground,
    inline,
    size,
    panelClassName,
    messagePanelClassName,
    messageClassName
}) {
    const sparkPanelClassName = classnames(
        'spark-message spark-panel',
        `spark-message--${type} spark-message--${size}`,
        panelClassName,
        {
            'no-border-panel': noBorder,
            'no-background': noBackground
        }
    );
    const iconName = _.cond([
        [() => !!icon, () => icon],
        [() => type === 'success', () => 'check'],
        [() => type === 'warning', () => 'alert-triangle'],
        [() => type === 'error', () => 'ban'],
        [() => type === 'info', () => 'note'],
        [() => true, () => 'check']
    ])();
    const iconClassName = classnames(`spark-message__icon spark-icon-${iconName} spark-icon--fill`, {
        'message__icon--xl': iconXL
    });
    const sparkMessagePanelClassName = classnames('spark-panel__content', messagePanelClassName);
    const sparkMessageContentClassName = classnames('spark-message__content', messageClassName, {
        'spark-message__inline': inline
    });

    return (
        <div className={sparkPanelClassName}>
            <div className={sparkMessagePanelClassName}>
                <i className={iconClassName} />
                <div className={sparkMessageContentClassName}>
                    <h4 className="spark-message__heading">{heading}</h4>
                    {!!body && <p>{body}</p>}
                    {!!bodyLink && (
                        <p>
                            <Link className={bodyLinkUrlStyle} to={bodyLinkUrl}>
                                {bodyLink}
                            </Link>
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}

Message.propTypes = {
    heading: PropTypes.string.isRequired,
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    bodyLink: PropTypes.string,
    bodyLinkUrl: PropTypes.string,
    bodyLinkUrlStyle: PropTypes.string,
    iconXL: PropTypes.bool,
    inline: PropTypes.bool,
    messageClassName: PropTypes.string,
    messagePanelClassName: PropTypes.string,
    noBackground: PropTypes.bool,
    noBorder: PropTypes.bool,
    panelClassName: PropTypes.string,
    size: PropTypes.string,
    type: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
    icon: PropTypes.string
};

Message.defaultProps = {
    icon: '',
    iconXL: false,
    inline: false,
    messageClassName: '',
    messagePanelClassName: '',
    noBackground: false,
    noBorder: false,
    panelClassName: '',
    size: 'lg',
    type: 'success'
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/message/Message.js